import axios from "axios";
export const updateRecord = (collection: string, _id: string, record: any) => {
  return axios.patch(
    `${process.env.REACT_APP_API_URL}/api/${collection}/${_id}`,
    record,
  );
};
